export default __webpack_public_path__ + "static/media/05.652086d9.jpg";